import React from 'react';

export default ({ providers, field }) => {
  const Element = providers.customElements.find(el => el.id === field.property).content;
  return <Element providers={providers} field={field} customProps={field.props || {}} />;
};
